import React from 'react';
import CircularLoader from '@common/CircularLoader';
import TrailQuestions from '../../questions/TrailQuestions';
import TrailWalkthrough from "../../walkthroughs/TrailWalkthrough";
import TrailWalkthroughResults from "../../walkthroughs/TrailWalkthroughResults";

const QuestionActivity = (props) => {
    const {step, stepActivity} = props;

    if (!step || !stepActivity) {
        return <CircularLoader />;
    }

    if (stepActivity.questionType === 'WALKTHROUGH') {
        return (
            <section className="ch-trail-question-activity">
                {step.complete ? (
                    <TrailWalkthroughResults {...props} />
                ) : (
                    <TrailWalkthrough
                        questionId={stepActivity.questionId}
                        conceptId={step.conceptId}
                        trailStepId={step.stepId}
                        onWalkthroughComplete={props.continueCurrentStep}
                    />
                )}
            </section>
        );
    }

    return (
        <section className="ch-trail-question-activity">
            <TrailQuestions {...props} />
        </section>
    );
};

export default QuestionActivity;